import { render, staticRenderFns } from "./condiciones-afiliaciones.vue?vue&type=template&id=5942c0a5&lang=html"
import script from "./condiciones-afiliaciones.vue?vue&type=script&lang=js"
export * from "./condiciones-afiliaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports